import { render, staticRenderFns } from "./TableRowView.vue?vue&type=template&id=4f1889bb"
import script from "./TableRowView.vue?vue&type=script&lang=js"
export * from "./TableRowView.vue?vue&type=script&lang=js"
import style0 from "./TableRowView.vue?vue&type=style&index=0&id=4f1889bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports